module.exports = {
    tag: 'rotting',
    quality: 0,
    toughness: -2,
    regeneration: -1.0
};